// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { deleteProductFamilies } from "./schema/delete-product-families";
import { getProductCatalog } from "./schema/get-product-catalog";
import { streamListingFieldOptimization } from "./schema/listing-field-optimization/stream-listing-field-optimization";
import { getProductTaxonomy } from "./schema/product-taxonomy-finder/get-product-taxonomy";
import { searchProductTaxonomy } from "./schema/product-taxonomy-finder/search-product-taxonomy";
import { publishProductFamilies } from "./schema/publish-product-families";
import { unpublishProductFamilies } from "./schema/unpublish-product-families";

export const groupH: {
  streamListingFieldOptimization: typeof streamListingFieldOptimization;
  deleteProductFamilies: typeof deleteProductFamilies;
  publishProductFamilies: typeof publishProductFamilies;
  unpublishProductFamilies: typeof unpublishProductFamilies;
  getProductCatalog: typeof getProductCatalog;
  getProductTaxonomy: typeof getProductTaxonomy;
  searchProductTaxonomy: typeof searchProductTaxonomy;
} = {
  streamListingFieldOptimization,
  deleteProductFamilies,
  publishProductFamilies,
  unpublishProductFamilies,
  getProductCatalog,
  getProductTaxonomy,
  searchProductTaxonomy,
};
